<template>
  <div class="press">
    <div class="campus">电商管理
       <span>></span>
    课程管理 
    <span>></span>
    免费课程 
    </div>
    
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部课程</div>
          <div class="tableStyle">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column label="课程封面" min-width="70">
                <template slot-scope="scope">
                  <img class="tableImg" :src="scope.row.coverUrl" />
                </template>
              </el-table-column>
              <el-table-column prop="name" label="课程名称" align="center">
              </el-table-column>
              <el-table-column prop="typeStr" label="课程类型" align="center">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="deletFree(scope.row)">删除</el-button>
                  <el-button type="text" @click="lookcourse(scope.row)">查看课程</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="dz-flex dz-flex-justify-end mt-12">
            <el-pagination background @size-change="getcourselist" @current-change="getcourselist" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'press',
  data() {
    return {
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      chooseClass:[],
      
    };
  },
  created() {
      this.getcourselist();
  },
  methods: {
      //添加课程
    addcourse() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course',
        method:'POST',
        data:{
            name:this.forms.name,
            price:this.forms.price,
            stock:this.forms.number,
            type:this.typeLabelValue,
            coverUrl:this.forms.picurl,
            detail:this.forms.details,
            hot:this.forms.hot,
            videoUrl:'',
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result,"sas");
          if (result.data.code === 0) {
              this.getcourselist();
              this.dialogType = false;
              this.$message.success('添加成功！' + err);
          } 
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('添加失败' + err);
        });
    },
   //查询列表
   getcourselist() {
      let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/free?'+'page='+this.page+'&pageSize='+this.pageSize,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result,"sas");
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            this.total = result.data.size;
          } 
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('查询失败：' + err);
        });
    },
    //删除免费书籍
    deletFree(row) {
        let orgid = window.sessionStorage.getItem('orgid');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/free/'+row.id,
        method:'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result,"sas");
          if (result.data.code === 0) {
              this.getcourselist();
              this.$message.error('删除成功！' + err);
          } 
        })
        .catch((err) => {
        });
    },
  },
};
</script>

<style lang="less" scoped>
.press {
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 135px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar-uploader {
    img {
      width: 120px;
      height: 120px;
    }
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
}
</style>
